module.exports = __webpack_public_path__ + "img/file-excel-solid.1bf4a3f4.svg";